import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import "leader-line";
import { CVFBoard } from "src/app/models/cvf-board";

@Component({
  selector: "cvf-mapping",
  templateUrl: "./cvf-mapping.component.html",
})

export class CvfMappingComponent implements OnInit {

  public serviceId: string;

  public board: CVFBoard = new CVFBoard();
  public lines: any[] = [];
  public readyFrom: boolean = false;
  public readyTo: boolean = false;

  public checkingVisibility: any = { value: false };

  constructor(
    private route: ActivatedRoute,
  ) { }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
  }

  public ngOnDestroy(): void {
    this.board.lines.forEach((line, i) => {
      if (line.line != null) {
          line.line.remove();
      }
    });
    this.board.lines = [];
  }

  public ready(who) {
    if (who === "to") {
      this.readyTo = true;
    }
    if (who === "from") {
      this.readyFrom = true;
    }
    if (this.readyTo && this.readyFrom && (this.lines.length !== this.board.lines?.length)) {
      // console.log("--- all is ready");
      this.initCVF();
    }
  }

  public getRelations(e) {
    this.lines = e;
  }

  public initCVF() {
    this.lines.forEach((line) => {
      let leaderLine = null;

      const start = document.getElementById(`from-${line.field}`);
      const end = document.getElementById(`to-${line.cvf[0]}`);
      // console.log(l, start, end);
      const exists = this.board.lines.find((l) => {
        return l.start === start && l.end === end;
      });
      if (start && end && !exists) {
        leaderLine = this.board.initLink(start, end);

        const newLine = {
          start,
          end,
          line: leaderLine,
        };
        this.board.lines.push(newLine);
      }
    });
    // console.log(this.board);
  }

  public hideLines(): void {
    this.board.lines.filter((line) => line.line && typeof line.line.hide === "function").forEach((line) => {
      line.line.hide();
  });
  }

  public sleep = (ms) => {
      return new Promise((resolve) => setTimeout(resolve, ms));
  };

  public scrolling = async () => {
      await this.sleep(150);
      this.board.lines.forEach((line) => { if (line.line && typeof line.line.hide === "function") { line.line.show(); }});
      this.checkScrollableRegionsHeight();
  };

  public handleScroll(boardId: string = ""): void {
    console.log("--- handleScroll");
    this.hideLines();
    this.scrolling();
  }

  public updateLinesVisibility(): void {
    document.querySelectorAll("div.has-scroll").forEach((region) => {
      this.handleHasScroll(region);
    });
  }

  public handleHasScroll(region: Element): void {
    region.querySelectorAll(".connected").forEach((regionField) => {
      if ((regionField.getBoundingClientRect().bottom) < (region.getBoundingClientRect().top) || regionField.getBoundingClientRect().top > region.getBoundingClientRect().bottom) {
        regionField.classList.add("overflowed");
      } else {
        regionField.classList.remove("overflowed");
      }
    });
  }

  public checkScrollableRegionsHeight(boardId: string = ""): void {
    document.querySelectorAll(".scrolled-region").forEach((region) => {
      const h = region.clientHeight;
      if (h >= 800) {
        region.classList.add("has-scroll");
      } else {
        region.classList.remove("has-scroll");
      }
      this.handleHasScroll(region);
    });
    this.checkLinesVisibility();
  }

  public checkLinesVisibility(boardId: string = ""): void {
    console.log(this.board.lines);
    this.board.lines.forEach((line) => {
      // console.log(line);
      const start = line.start;
      const end = line.end;
      if (start && end) {
          const nohidden =
              start.style.display !== "none" && !start.classList.contains("hidden")
              && !start.classList.contains("overflowed")
              && end.style.display !== "none"
              && !end.classList.contains("hidden")
              && !end.classList.contains("overflowed");
          if (nohidden) {
              // remove connected-non-visible class
              line.line.show();
              start.classList.remove("connected-non-visible");
              end.classList.remove("connected-non-visible");
          } else {
              this.hideVisualLine(line);
              // add connected-non-visible class
              start.classList.add("connected-non-visible", "connected");
              end.classList.add("connected-non-visible", "connected");
          }
      } else {
          this.hideVisualLine(line);
          // add connected-non-visible class
          if (start) { start.classList.add("connected-non-visible", "connected"); }
          if (end) { end.classList.add("connected-non-visible", "connected"); }
      }
    });
    this.updateRelationshipsPositions();
    this.checkingVisibility.value = false;
  }

  public hideVisualLine(line): void {
    if (line.line === null) { return; }
    line.line.hide();
  }

  public updateRelationshipsPositions(): void {
    this.board.lines.filter((line) => line.line !== null).forEach((line) => {
          const start = line.start;
          const end = line.end;
          if (line.line) {
              if (start && end && !start.classList.contains("overflowed") && !start.classList.contains("connected-non-visible") &&
                  !end.classList.contains("overflowed") && !end.classList.contains("connected-non-visible")) {
                line.line.setOptions({ start, end });
                line.line.position();
              } else {
                  line.line.hide();
              }
          }
      });
  }

}
